import { PromoCodeCreatedBy, PromoCodeTag } from '../../../../../../services/exports/Constants';

export default {
  title: 'Alennuskoodit',
  tabs: {
    active: 'Aktiivinen',
    expired: 'Vanhentunut',
    email_sign_up: 'Mainospostitusliittyminen',
  },
  show_master_promo_code: 'Näytä pääalennuskoodi asiakkaille',
  send_rejected_order_apologies_promo_code: 'Lähetä alennuskoodi asiakkaille, kun tilaus hylätään manuaalisesti',
  filters: {
    tag: {
      placeholder: 'Tunniste',
      options: {
        [PromoCodeTag.Master]: 'Pääkoodi',
        [PromoCodeTag.Campaign]: 'Kampanja',
        [PromoCodeTag.OneTime]: 'Kertakäyttöinen',
      },
    },
    code: {
      placeholder: 'Koodi',
    },
    campaign: {
      placeholder: 'Kampanja',
    },
    created_by: {
      placeholder: 'Luonut',
      options: {
        [PromoCodeCreatedBy.User]: 'Käyttäjä',
        [PromoCodeCreatedBy.System]: 'Järjestelmä',
      },
    },
  },
  fields: {
    code: 'Koodi',
    tag: 'Tunniste',
    type: 'Tyyppi',
    discount_type: 'Alennustyyppi',
    discount: 'Alennus',
    usage_threshold: 'Käyttöraja',
    quantity: 'Määrä',
    expires_at: 'Vanhenee',
    level: 'Taso',
    max_discount: 'Enimmäisalennus',
    created_by: 'Luonut',
    image: 'Kuva',
  },
  tags: {
    [PromoCodeTag.Master]: 'Pääkoodi',
    [PromoCodeTag.Campaign]: 'Kampanja',
    [PromoCodeTag.OneTime]: 'Kertakäyttöinen',
  },
  types: {
    single_use: 'Kertakäyttöinen',
    multi_use: 'Monikäyttöinen',
    unknown: 'Tuntematon',
  },
  discount_types: {
    fixed_amount: 'Kiinteä summa',
    percentage: 'Prosentti',
    unknown: 'Tuntematon',
  },
  created_by: {
    [PromoCodeCreatedBy.User]: 'Käyttäjä',
    [PromoCodeCreatedBy.System]: 'Järjestelmä',
  },
  labels: {
    discount: 'Alennus',
    usage_threshold: 'Käyttöraja',
    company: 'Yritys',
    restaurant: 'Ravintola',
    restaurant_group: 'Brändi',
  },
  buttons: {
    add: 'Lisää',
    edit: 'Muokkaa',
    delete: 'Poista',
    restore: 'Palauta',
    add_promo_code: 'Lisää alennuskoodi',
    images: 'Hallitse kuvaa',
  },
  toasts: {
    failed_to_load_data: 'Tietojen lataaminen epäonnistui',
    failed_to_save_settings: 'Muutosten tallentaminen epäonnistui',
    failed_to_delete_promo_code: 'Alennuskoodin poistaminen epäonnistui',
    failed_to_restore_promo_code: 'Alennuskoodin palauttaminen epäonnistui',
    promo_code_got_deleted: 'Alennuskoodi poistettiin',
    promo_code_got_restored: 'Alennuskoodi palautettiin',
  },
  delete_confirmation: {
    title: 'Poistetaanko alennuskoodi?',
    buttons: {
      yes: 'Kyllä',
      no: 'Ei',
    },
  },
  restore_confirmation: {
    title: 'Palautetaanko alennuskoodi?',
    buttons: {
      yes: 'Kyllä',
      no: 'Ei',
    },
  },
};
